var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('POIStep',{attrs:{"position":_vm.position,"step":_vm.step,"title":"Veranstalter / Veranstaltungsort"},on:{"changeStep":_vm.changeStep}},[_c('PoiOplocFields',{attrs:{"editedItem":_vm.editedItem,"isOwnedBySubPrincipal":_vm.isOwnedBySubPrincipal},on:{"save":_vm.saveHelper}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }